/* Beautiful Body · BB · Campaña con conteo (bb-promo)
   Conteo regresivo, carrusel (flechas, barra y arrastre con el mouse), brillo
   que sigue al cursor y entrada de las tarjetas. Todo por delegación o con un
   barrido cada segundo, así sigue funcionando cuando el editor vuelve a pintar la sección. */
(function () {
  if (window.__bbPromo) return;
  window.__bbPromo = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15 }) : null;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function setText(root, u, v) {
    var el = root.querySelector('[data-u="' + u + '"]');
    if (el && el.textContent !== v) el.textContent = v;
  }

  // ---------- conteo + preparar secciones nuevas ----------
  function sweep() {
    document.querySelectorAll('[data-bb-promo]').forEach(function (root) {
      if (!root.__bbInit) {
        root.__bbInit = true;
        if (io && !reduce) { root.classList.add('is-ready'); io.observe(root); }
        var rail = root.querySelector('[data-bb-rail]');
        if (rail) updateRail(rail);
      }
      // respaldo por si el observador no avisa (pestaña en segundo plano, etc.)
      if (!root.classList.contains('is-in')) {
        var box = root.getBoundingClientRect();
        if (box.top < window.innerHeight * 0.85 && box.bottom > 0) root.classList.add('is-in');
      }
      var end = Date.parse(root.getAttribute('data-end') || '');
      if (isNaN(end)) return;
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (left === 0 && root.hasAttribute('data-hide-after') && !(window.Shopify && window.Shopify.designMode)) {
        var wrap = root.closest('.shopify-section') || root;
        wrap.hidden = true;
        return;
      }
      setText(root, 'd', String(Math.floor(left / 86400)));
      setText(root, 'h', pad(Math.floor(left / 3600) % 24));
      setText(root, 'm', pad(Math.floor(left / 60) % 60));
      setText(root, 's', pad(left % 60));
    });
  }

  // ---------- carrusel ----------
  function updateRail(rail) {
    var root = rail.closest('[data-bb-promo]');
    if (!root) return;
    var max = rail.scrollWidth - rail.clientWidth;
    var bar = root.querySelector('[data-bb-rail-bar]');
    var prev = root.querySelector('[data-bb-rail-prev]');
    var next = root.querySelector('[data-bb-rail-next]');
    var thumb = rail.scrollWidth ? Math.min(100, rail.clientWidth / rail.scrollWidth * 100) : 100;
    var ratio = max > 0 ? rail.scrollLeft / max : 0;
    if (bar) {
      bar.style.setProperty('--bb-thumb', thumb + '%');
      // translateX en % del propio ancho de la barra
      bar.style.setProperty('--bb-pos', (thumb < 100 ? ratio * (100 - thumb) / thumb * 100 : 0) + '%');
    }
    if (prev) prev.disabled = rail.scrollLeft <= 4;
    if (next) next.disabled = rail.scrollLeft >= max - 4;
  }
  function step(rail) {
    var item = rail.querySelector('.bb-promo__item');
    var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
    var w = item ? item.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
    return Math.max(w, Math.floor(rail.clientWidth / w) * w);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bb-rail-prev], [data-bb-rail-next]');
    if (!btn) return;
    var root = btn.closest('[data-bb-promo]');
    var rail = root && root.querySelector('[data-bb-rail]');
    if (!rail) return;
    var dir = btn.hasAttribute('data-bb-rail-next') ? 1 : -1;
    rail.scrollBy({ left: dir * step(rail), behavior: reduce ? 'auto' : 'smooth' });
  });

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-bb-rail]')) updateRail(t);
  }, true);
  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-bb-rail]').forEach(updateRail);
  });

  // arrastrar con el mouse (en pantallas táctiles el carrusel ya se desliza solo)
  var drag = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var rail = e.target.closest('[data-bb-rail]');
    if (!rail) return;
    drag = { rail: rail, x: e.clientX, left: rail.scrollLeft, moved: false };
  });
  document.addEventListener('pointermove', function (e) {
    if (drag) {
      var dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 6) { drag.moved = true; drag.rail.classList.add('is-dragging'); }
      if (drag.moved) { drag.rail.scrollLeft = drag.left - dx; e.preventDefault(); }
      return;
    }
    // brillo que sigue al cursor
    if (e.pointerType !== 'mouse') return;
    var card = e.target.closest && e.target.closest('[data-bb-spot]');
    if (!card) return;
    var r = card.getBoundingClientRect();
    card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
    card.style.setProperty('--my', (e.clientY - r.top) + 'px');
  });
  function endDrag() {
    if (!drag) return;
    var d = drag;
    drag = null;
    if (!d.moved) return;
    // al soltar, deja que el carrusel se acomode en la tarjeta más cercana
    var before = d.rail.scrollLeft;
    d.rail.classList.remove('is-dragging');
    var after = d.rail.scrollLeft;
    if (before !== after) {
      d.rail.scrollLeft = before;
      d.rail.scrollTo({ left: after, behavior: reduce ? 'auto' : 'smooth' });
    }
    // evita que el clic al soltar abra la tarjeta
    var block = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
    document.addEventListener('click', block, true);
    setTimeout(function () { document.removeEventListener('click', block, true); }, 0);
  }
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sweep);
  else sweep();
  setInterval(sweep, 1000);
  document.addEventListener('shopify:section:load', sweep);
})();
